import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";
import { onPreloadError } from "./lib/chunk-reload";

initSentry();

// VIB-945: Vite dispatcher `vite:preloadError` når en modul-preload feiler etter
// en deploy (stale bundle). lazyWithReload dekker selve React.lazy-importene;
// denne dekker preload-helperen. Selve regelen (preventDefault kun når vi
// faktisk reloader) bor i `chunk-reload.ts`, der den er testet — se VIB-2788.
window.addEventListener("vite:preloadError", onPreloadError);

createRoot(document.getElementById("root")!).render(<App />);
